import {Component, OnInit, ViewChild} from '@angular/core';
import {language} from '../../../language/vn';
import {DonVi} from '../../../models/danhmuc/donvi';
import {DonViService} from '../../../service/danhmuc/service-donvi';
import {TreeViewComponent, NodeSelectEventArgs} from '@syncfusion/ej2-angular-navigations';
import {EditKeHoachComponent} from '../../info/kehoach/edit.component';
import {BsModalService} from 'ngx-bootstrap/modal';
import {EditDonViNoiBoComponent} from './edit.component';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {ToastrService} from 'ngx-toastr';
@Component({

  templateUrl: './donvinoibo.component.html'
})
export class DonViNoiBoComponent implements OnInit {
  public language = language;
  public data: Object[];
  public fieldTree: Object;
  public dataTree: DonVi[];
  public dataDonVi: Object[] = [];
  public  dataId: number =0;
  public showCheckBox: boolean = true;
  @ViewChild('treeview') public tree: TreeViewComponent;
  constructor(
    public donViService: DonViService,
    public bsModalService: BsModalService,
    public toastr: ToastrService
  ) {

  }

  ngOnInit(): void {
      this.showTree();
  }
   showTree()
  {
    this.donViService.getAllByActive(-1).subscribe(x => {
      this.dataTree = x;
      this.dataDonVi = [];
      for (let i = 0; i < this.dataTree.length; i++) {
        this.dataDonVi.push(
          this.dataTree[i].maCapTren == 0 ?
            {
              id: this.dataTree[i].id,
              name: this.dataTree[i].tenCQ,
              hasChild: this.dataTree[i].hasChild,
              expanded: true
            }
            :
            {
              id: this.dataTree[i].id,
              pid: this.dataTree[i].maCapTren,
              name: this.dataTree[i].tenCQ,
              hasChild: this.dataTree[i].hasChild,
              expanded: false
            });
      }
      this.fieldTree = {dataSource: this.dataDonVi, id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild'};

    });
  }
  public showConfirmationModal(): void {
    if(this.dataId !== 0) {
      const modal = this.bsModalService.show(ConfirmDialogComponent);
      (<ConfirmDialogComponent>modal.content).showConfirmationModal(
        language.message,
        language.confirm_delete_question,
        language.yes,
        language.no
      );
      (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
        if (result === true) {
          this.deleteItem(this.dataId);
        }
      });
    } else
    {
      this.toastr.warning(language.error_select_record, language.message);
    }

  }

  deleteItem(id: number)
  {
    this.donViService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.showTree();
      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  public addChild(): void {
    if(this.dataId !== 0) {
      const modalEdit = this.bsModalService.show(EditDonViNoiBoComponent, {class: 'modal-lg'});
      (<EditDonViNoiBoComponent>modalEdit.content).child(
        this.dataId
      );
      (<EditDonViNoiBoComponent>modalEdit.content).onClose.subscribe(result => {
        if (result === true) {
          this.showTree();

        }
      });
    }
    else
    {
      this.toastr.warning(language.error_select_record, language.message);
    }
  }
  public edit(ty): void {

    if(this.dataId !== 0 || ty ===0) {
      const modalEdit = this.bsModalService.show(EditDonViNoiBoComponent, {class: 'modal-lg'});
      (<EditDonViNoiBoComponent>modalEdit.content).edit(
        ty===0? 0: this.dataId
      );
      (<EditDonViNoiBoComponent>modalEdit.content).onClose.subscribe(result => {
        if (result === true) {
          this.showTree();

        }
      });
    }
    else
    {
      this.toastr.warning(language.error_select_record, language.message);
    }
  }

  public nodeChecked(e: NodeSelectEventArgs): void {
      this.dataId= Number(this.tree.selectedNodes[0]);

  }

  }



